import { render, staticRenderFns } from "./SurveyOptions.vue?vue&type=template&id=832c5dd2&"
import script from "./SurveyOptions.vue?vue&type=script&lang=js&"
export * from "./SurveyOptions.vue?vue&type=script&lang=js&"
import style0 from "./SurveyOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Checkbox: require('/home/runner/work/myody_front/myody_front/components/checkbox/Checkbox.vue').default})
